import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { useCongress } from './congress/hooks'
import Speakers from './pages/Speakers'
import Sponsors from './pages/Sponsors'
import Program from './pages/Program'
import Stands from './pages/Stands'
import Layout from './components/Layout'
import SpeakerDetail from './pages/SpeakerDetail'
import SponsorDetail from './pages/SponsorDetail'
import Information from './pages/Information'
import Contact from './pages/Contact'
import ContactForm from './pages/ContactForm'

export default function Router () {
  const { generateLink } = useCongress()

  return (
    <Layout>
      <Switch>
        <Route path={generateLink('')} exact><Information/></Route>
        <Route path={generateLink('/information')} exact><Information/></Route>
        <Route path={generateLink('/speakers')} exact><Speakers/></Route>
        <Route path={generateLink('/speakers/:id')} exact><SpeakerDetail/></Route>
        <Route path={generateLink('/sponsors')} exact><Sponsors/></Route>
        <Route path={generateLink('/sponsors/:id')} exact><SponsorDetail/></Route>
        <Route path={generateLink('/program')} exact><Program/></Route>
        <Route path={generateLink('/stands')} exact><Stands/></Route>
        <Route path={generateLink('/contact')} exact><Contact/></Route>
        <Route path={generateLink('/contact/:id&:multiple')} exact><ContactForm/></Route>
      </Switch>
    </Layout>
  )
}